import { render, staticRenderFns } from "./configuracion.vue?vue&type=template&id=36d1e83a&scoped=true"
import script from "./configuracion.vue?vue&type=script&lang=js"
export * from "./configuracion.vue?vue&type=script&lang=js"
import style0 from "./configuracion.vue?vue&type=style&index=0&id=36d1e83a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d1e83a",
  null
  
)

export default component.exports